/*
 * This module is the application's main script.
 *
 * The code here should be only that which is strictly necessary for all/most pages of the application.
 *
 */

import {SearchFilter} from "./SearchFilter.js"
import {KendoGridSaveState} from "./KendoGridSaveState.js"
import {KendoGridStickyScrollbar} from "./KendoGridStickyScrollbar.js"
import {NoticeMessage} from "../components/NoticeMessage.js"
import {AsyncRequest} from "../components/AsyncRequest.js"
import {UserId} from "../components/UserId.js"
import {IdentityPopover} from "./IdentityPopover.js"
import {Sidebar} from "./Sidebar.js"

{// prevent double submission
    // Tracks which submit button triggered each form submission so we can target it with the loading state
    const submittingButtons = new WeakMap<HTMLFormElement, HTMLButtonElement>();

    document.addEventListener("click", (e) => {
        const button = (e.target as HTMLElement | null)?.closest<HTMLButtonElement>('[type="submit"]');
        if (!button) return;
        const form = button.closest("form");
        if (form) submittingButtons.set(form, button);
    });

    document.addEventListener("submit", (e) => {
        // A handler upstream (e.g. a confirmation-modal guard) may have cancelled the actual submission;
        // don't lock the button into its loading state if the form never actually submitted.
        if (e.defaultPrevented) return;

        const form = e.target as HTMLFormElement;
        const button = submittingButtons.get(form) ?? form.querySelector<HTMLButtonElement>('[type="submit"]');
        if (!button) return;
        // Defer so the browser collects form data (including this button's name/value) before it is disabled.
        // Disabled fields are excluded from form data, which would break server-side authorization checks that depend on the submitted button value.
        setTimeout(() => {
            button.disabled = true;
            button.insertAdjacentHTML("afterbegin", '<i class="k-icon k-font-icon k-i-arrow-rotate-cw spin"></i>');
        }, 0);
    });
}

NoticeMessage.init()
AsyncRequest.init()
UserId.init()

$(() => {
    new SearchFilter()
    KendoGridSaveState.initAll()
    IdentityPopover.init()
    KendoGridStickyScrollbar.initAll()
    Sidebar.init()
})
